import React from 'react';
import { ChevronLeft, ChevronRight, ScanFace } from 'lucide-react';
import { useLanguage } from '../i18n/LanguageContext';
import { Link } from 'react-router-dom';
export function HeroSection() {
  const {
    t
  } = useLanguage();
  return <section className="relative h-[80vh] min-h-[600px] bg-black overflow-hidden pt-28" data-id="element-530">
      {/* Background — solid premium gradient */}
      <div className="absolute inset-0 bg-gradient-to-br from-brand-darkCopper via-gray-900 to-black" data-id="element-531"></div>

      {/* Subtle radial accent */}
      <div className="absolute inset-0 bg-[radial-gradient(ellipse_at_center,_rgba(199,146,104,0.15)_0%,_transparent_60%)]" data-id="element-532"></div>

      {/* Soft overlay for text contrast */}
      <div className="absolute inset-0 bg-black/20" data-id="element-533"></div>

      <div className="relative h-full max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 flex flex-col justify-center items-center text-center" data-id="element-534">
        <h1 className="text-4xl md:text-6xl lg:text-7xl font-light text-white mb-6 tracking-tight" data-id="element-535">
          {t('hero.title1')}{' '}
          <span className="font-semibold text-brand-lightCopper" data-id="element-536">
            {t('hero.title2')}
          </span>
        </h1>
        <p className="text-lg md:text-xl text-gray-200 max-w-2xl mb-10 font-light" data-id="element-537">
          {t('hero.subtitle')}
        </p>
        <div className="flex flex-col sm:flex-row space-y-4 sm:space-y-0 sm:space-x-4" data-id="element-538">
          <Link to="/products" className="bg-brand-copper text-white px-8 py-3 rounded-sm font-medium hover:bg-brand-darkCopper transition-colors inline-flex items-center justify-center" data-id="element-539">
            {t('hero.viewProducts')}
          </Link>
          <Link to="/face-analysis" className="bg-white text-brand-darkCopper px-8 py-3 rounded-sm font-medium hover:bg-gray-100 transition-colors inline-flex items-center justify-center shadow-lg shadow-white/10" data-id="element-540">
            <ScanFace className="w-5 h-5 mr-2" data-id="element-541" />
            {t('faceAnalysis.heroCta')}
          </Link>
          <Link to="/contact" className="border border-white text-white px-8 py-3 rounded-sm font-medium hover:bg-white/10 transition-colors inline-flex items-center justify-center" data-id="element-542">
            {t('hero.contactUs')}
          </Link>
        </div>
      </div>

      {/* Carousel Controls */}
      <button className="absolute left-4 md:left-8 top-1/2 -translate-y-1/2 w-12 h-12 flex items-center justify-center rounded-full bg-black/20 text-white hover:bg-black/40 transition-colors backdrop-blur-sm" data-id="element-543">
        <ChevronLeft size={24} data-id="element-544" />
      </button>
      <button className="absolute right-4 md:right-8 top-1/2 -translate-y-1/2 w-12 h-12 flex items-center justify-center rounded-full bg-black/20 text-white hover:bg-black/40 transition-colors backdrop-blur-sm" data-id="element-545">
        <ChevronRight size={24} data-id="element-546" />
      </button>

      {/* Carousel Indicators */}
      <div className="absolute bottom-8 left-1/2 -translate-x-1/2 flex space-x-2" data-id="element-547">
        <div className="w-8 h-1 bg-brand-copper rounded-full" data-id="element-548"></div>
        <div className="w-8 h-1 bg-white/50 rounded-full cursor-pointer hover:bg-white/80 transition-colors" data-id="element-549"></div>
        <div className="w-8 h-1 bg-white/50 rounded-full cursor-pointer hover:bg-white/80 transition-colors" data-id="element-550"></div>
      </div>
    </section>;
}